import { render, staticRenderFns } from "./AdminSentimentVguard.vue?vue&type=template&id=5bb67e27&scoped=true"
import script from "./AdminSentimentVguard.vue?vue&type=script&lang=js"
export * from "./AdminSentimentVguard.vue?vue&type=script&lang=js"
import style0 from "./AdminSentimentVguard.vue?vue&type=style&index=0&id=5bb67e27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb67e27",
  null
  
)

export default component.exports